<template>
  <div>
    <v-snackbar absolute top :timeout="3000" v-model="snackbar">{{
      snackbarText
    }}</v-snackbar>
    <v-dialog v-model="active" max-width="650" persistent>
      <options-dialog @cancel="cancel" @to="goTo"></options-dialog>
    </v-dialog>
  </div>
</template>

<script>
import optionsDialog from "@/components/options-dialog";
import { db } from "@/firebase";
import { mapActions } from "vuex";

export default {
  name: "Menu",
  components: {
    optionsDialog,
  },
  data() {
    return {
      business: {},
      active: true,
      snackbarText: "",
      snackbar: false,
    };
  },
  methods: {
    ...mapActions(["showSearch"]),
    cancel() {
      this.$router.push({ path: "/tracking/1" });
    },
    goTo(item) {
      if (item.needPermission && !this.business[item.permissionFlag]) {
        this.snackbarText =
          "Debes solicitar este acceso al personal de Dilo Delivery, comunícate con tu asesor de Dilo Delivery";
        this.snackbar = true;
        // this.$store.commit(
        //   "setNotification",
        //   "Debes solicitar este acceso al personal de Ocho, favor ponte en contacto con tu asesor de Ocho"
        // );
        // this.$store.commit("setNotification", true);
        return;
      }
      this.$router.push({ path: `${item.to}#close` });
    },
  },
  async mounted() {
    this.$store.commit("setNavBar", true);
    this.$store.commit("setLoading", "");
    this.showSearch(false);
    // console.log(i);
    await this.$binding(
      "business",
      db
        .collection(`businessesCorporative`)
        .doc(this.$store.state.user.businessID)
    )
      .then(async () => {})
      .catch((err) => {
        // console.log("didnt bind business", err);
      });
  },
};
</script>